import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classnames from "classnames";
import withErrorBoundary from "../decorators/withErrorBoundary";
import withMobileContext from "../decorators/withMobileContext";
import {
  productSelector,
  isShownProductsSelector,
  onPlatformSelector,
  mobileAppSelector
} from "../selectors";
import Products from "./Products";
import Product from "./Product";
import ActionPanel from "./ActionPanel";
import RealisticView from "./RealisticView";
import Navigation from "./Navigation";
import ObjectManager from "./ObjectManager";
import SideControl from "./SideControl";
import TextControl from "./TextControl";
import VariantControl from "./VariantControl";
import SystemControl from "./SystemControl";
import EditControl from "./EditControl";
import BackgroundControl from "./BackgroundControl";
import StaticObjectControl from "./StaticObjectControl";
import ThreeDPreview from "./ThreeDPreview";
import DrawControl from "./DrawControl";
import Instruments from "./Instruments";

class Root extends React.Component {
  static propTypes = {
    product: PropTypes.object,
    isMobile: PropTypes.bool,
    isShownProducts: PropTypes.bool,
    onPlatform: PropTypes.string,
    mobileApp: PropTypes.bool
  };
  componentDidMount() {
    const jssStyles = document.getElementById(`jss-server-side`);
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }
  render() {
    const {
      product: {
        meta: {translated_product: h1Text}
      },
      product,
      isMobile,
      isShownProducts,
      onPlatform,
      mobileApp
    } = this.props;
    return (
      <div
        className={classnames(`resp-container`, `content`, {
          [`content_vtb`]: onPlatform === `vtb`
        })}
      >
        {(isShownProducts || !isMobile) && (
          <div className="row">
            <Products />
            {!isMobile && <VariantControl />}
          </div>
        )}
        {!isMobile && (
          <div className="row">
            <div className="col-xs-12 col-md-11 col-md-offset-1">
              <h1 className="content__title">{h1Text}</h1>
            </div>
          </div>
        )}
        {!mobileApp && isMobile && (
          <div className="row">
            <div className="col-xs-12">
              <Navigation />
            </div>
          </div>
        )}
        <div className={`row${!isShownProducts || !isMobile ? `` : ` hidden`}`}>
          <div className={isMobile ? `hidden` : `col-md-1 content__sides`}>
            {!isMobile && <SideControl />}
          </div>
          <div className={isMobile ? `col-xs-12` : `col-md-7`}>
            {isMobile && (
              <React.Fragment>
                <ObjectManager />
                <div className="content__top">
                  <VariantControl />
                  <SystemControl />
                </div>
              </React.Fragment>
            )}
            <Product />
            {!isMobile && (
              <div className="previews">
                <RealisticView />
                <ThreeDPreview />
              </div>
            )}
            {isMobile && (
              <React.Fragment>
                <div className="panel-controls">
                  <TextControl />
                  <Instruments />
                  <EditControl />
                  <DrawControl />
                  <BackgroundControl />
                  <StaticObjectControl />
                </div>
                <SideControl />
                <div className="previews">
                  <RealisticView />
                  <ThreeDPreview />
                </div>
                <ActionPanel isOwner={!product.raw_parent_id} />
              </React.Fragment>
            )}
          </div>
          <div className={classnames({
            'col-xs-12': isMobile,
            'col-md-4': !isMobile,
            'd-controls-container': !isMobile
          })}>
            {!isMobile && (
              <React.Fragment>
                <ObjectManager />
                <div className="panel-controls">
                  <SystemControl />
                  <EditControl />
                  <TextControl />
                  <DrawControl />
                  <BackgroundControl />
                  <StaticObjectControl />
                </div>
                <ActionPanel isOwner={!product.raw_parent_id} />
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  product: productSelector(state),
  isShownProducts: isShownProductsSelector(state),
  onPlatform: onPlatformSelector(state),
  mobileApp: mobileAppSelector(state)
}))(withErrorBoundary(withMobileContext(Root)));
